<div class="st-form">
  <app-st-impersonation-floating-banner [impersonatedEmail]="this.impersonatedEmail"
                                        [username]="this.username"
                                        [roleName]="this.consultantRoleName"
                                        (exitViewAs)="this.onExitViewAs($event)"
  >

  </app-st-impersonation-floating-banner>
</div>
<app-st-banner [idVal]="'banner-id'" [breadCrumbs]="this.breadCrumbs"
               [hasElementTags]="false" [elementTags]="[]" [requiresSignOutButton]="true"
></app-st-banner>
<br><br><br><br><br>
<div class="container-xxl">
  <app-st-header-title [inputVal]="this.pageTitle"></app-st-header-title>
  <br>
  <div *ngIf="showPageErrorMessages" class="container st-form text-danger" #goUp>
    <app-st-span [inputVal]="'An error has occurred: '"></app-st-span>
    <div *ngFor="let errorMsg of pageErrorMessages" class="alert alert-danger" role="alert">
      <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
    </div>
    <br>
  </div>
  <div *ngIf="this.showPageSuccessMessages" class="container st-form text-success" #goUp>
    <div *ngFor="let successMsg of pageSuccessMessages" class="alert alert-success" role="alert">
      <b>{{successMsg.field}}:</b> {{successMsg.detail}}
    </div>
    <br>
  </div>
  <br>
  <div class="container st-form">
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
      <app-st-button-cancel [idVal]="'top-cancel-button-id'" [label]="'Cancel'" [primary]="false"
                            (click)="this.onCancel()"></app-st-button-cancel>
      <app-st-button *ngIf="(this.username && this.impersonatedEmail == null) ||
                        (this.impersonatedEmail != null && this.consultantRoleName == 'COLLABORATIVE_ACCESS')"
                    [idVal]="'top-save-button-id'" [label]="'Save'" [primary]="true"
                     (click)="this.onSave()"

      ></app-st-button>
    </div>
    <div class="row pt-2">
      <div class="col">
        <app-st-input-text [idVal]="'funding-goal-name-text-id'"
                           [label]="'Funding Goal Name'" [inputVal]="savedFundingGoalName"
                           [maxLength]="100"
                           [disabled]="this.readOnly"
        ></app-st-input-text>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <app-st-date-picker [idVal]="'due-date-text-id'"
                           [label]="'Due Date'" [inputVal]="savedDueDate"
                            [disabled]="this.readOnly"
        ></app-st-date-picker>
      </div>
      <div class="col">
        <app-st-input-currency-text [idVal]="'funding-amount-needed-text-id'"
                           [label]="'Funding Amount Needed'" [inputVal]="savedFundingAmtNeeded"
                            [currencySymbolVal]="' ($ USD)'" (input)="formatMoneyOnChange()"
                                    [disabled]="this.readOnly"
        ></app-st-input-currency-text>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <app-st-textarea [idVal]="'funding-goal-description-id'"
                           [label]="'Description'" [inputVal]="savedDescription"
                            [rows]="20" [cols]="100" [requiredVal]="true"
                         [disabled]="this.readOnly"
        ></app-st-textarea>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <app-st-input-text [idVal]="'funding-goal-created-ts-id'"
                           [label]="'Created Timestamp'" [placeHolderVal]="''" [inputVal]="savedCreatedTS" [disabled]="true"></app-st-input-text>
      </div>
      <div class="col">
        <app-st-input-text [idVal]="'funding-goal-updated-ts-id'"
                           [label]="'Updated Timestamp'" [placeHolderVal]="''" [inputVal]="savedUpdatedTS" [disabled]="true"></app-st-input-text>
      </div>
    </div>
    <br><br>
    <app-st-span [inputVal]="'Saved Searches: '" class="webtext-black-bold"></app-st-span>
    <div *ngIf="!this.readOnly">
      <app-st-select [idVal]="'saved-searches-dropdown-list-id'" [defaultOption]="'Select Saved Search'" [label]="''" [idKey]="'savedSearchId'" [displayKey]="'savedSearchName'" [valueKey]="'savedSearchName'" [inputArray]="this.savedSearchList" ></app-st-select>
      <br>
      <app-st-button [idVal]="'add-saved-search-button-id'" [label]="'Add'" [primary]="true"
                     (click)="this.onAddSavedSearchMapping()"></app-st-button>
    </div>
    <br>
    <br>
    <table class="table table-stripe webtext-black">
      <thead>
      <tr>
        <th scope="col">Saved Search Name</th>
        <th scope="col">Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let savedSearchFundingGoalMapping of savedSearchFundingGoalMappings">
        <td>{{savedSearchFundingGoalMapping['savedSearchName']}}</td>
        <td>
          <a *ngIf="(this.username && this.impersonatedEmail == null) || (this.impersonatedEmail != null && this.consultantRoleName == 'COLLABORATIVE_ACCESS')"
            (click)="onDeleteSavedSearchFundingGoalMapping(savedSearchFundingGoalMapping)">
            <i class="bi bi-trash"></i>
          </a>
          &nbsp;
          <a (click)="onApplySavedSearch(savedSearchFundingGoalMapping)">
            <i class="bi bi-search"></i>
          </a>
        </td>
      </tr>
      </tbody>
    </table>
    <br>
    <app-st-button-back-to-top></app-st-button-back-to-top>
    <br><br>
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
      <app-st-button-cancel [idVal]="'bottom-cancel-button-id'" [label]="'Cancel'" [primary]="false"
                            (click)="this.onCancel()"></app-st-button-cancel>
      <app-st-button *ngIf="(this.username && this.impersonatedEmail == null) ||
                        (this.impersonatedEmail != null && this.consultantRoleName == 'COLLABORATIVE_ACCESS')"
                    [idVal]="'bottom-save-button-id'" [label]="'Save'" [primary]="true"
                     (click)="this.onSave()">
      </app-st-button>
    </div>
    <br>
  </div>
</div>
<br>
